import axios from "axios";
const base = `${process.env.REACT_APP_BASE_URL.replace(/\/+$/, "")}/delivery-handoffs`;
const options = () => ({ headers: { Authorization: localStorage.getItem("adminToken") || "" } });
const value = response => {
  if (response.data.status !== "SUCCESS") throw new Error(response.data.message || "Elite request failed");
  return response.data.data;
};
export default {
  list: async params => value(await axios.get(base, { ...options(), params })),
  history: async id => value(await axios.get(`${base}/${id}/attempts`, options())),
  action: async (id, action, reason, recovery = {}) => value(await axios.post(`${base}/${id}/${action}`, { reason, ...recovery }, options())),
};
